<div class="video-wrapper" fxLayout="column" [ngClass]="{'show-backdrop': showBackDrop}">
    <video #videoPlayer *ngIf="videoUrl" [attr.controls]="showControls ? '' : null" playsinline webkit-playsinline>
        <source [src]="videoUrl" type="video/mp4">
        Your browser does not support the video tag.
    </video>
    <!-- ORCA-1977: a capa inteira abre o vídeo, não só o botão -->
    <div class="play-button" *ngIf="!isPlaying" (click)="onCoverClick($event)">
        <button mat-icon-button type="button"
        matTooltip="Clique para reproduzir o vídeo"
        aria-label="Reproduzir o vídeo">
            <mat-icon>play_arrow</mat-icon>
        </button>
    </div>
</div>
